/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import LCD from '@appblocks/codegeneration/Features/LCD';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;

    const WIDGET = feature.getSettingValue('WIDGET');

    if (!WIDGET) return blocks;

    const IMG = feature.getSettingValue('IMG');

    const links = project.getNodeLinks(feature, 'lcd_image');
    const doneLinks = project.getNodeLinks(feature, 'done');

    const doneBlock = doneLinks.length > 0 ? `${project.getCodeLocationStart()}${doneLinks[0].getSourceId()}${project.getCodeLocationEnd()}` : '';

    for (let i = 0; i < links.length; i++) {
        const link = links[i];
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
        simulator.updateContext("${WIDGET}", {
            ...simulator.context["${WIDGET}"],
            IMG: "${IMG}",
        });
        ${doneBlock}`,
        });
    }
    return blocks;
};
